import {CommonMessages} from '../common.messages';

export const PanelReportsAccountsMessages = {
    GetTradingGroupsFailed: {
        key: 'GetTradingGroupsFailed',
        message: 'Error while communication with the server. Unable to get trading groups.'
    },
    WrongDateFromValue: {
        key: 'WrongDateFromValue',
        message: 'The "Date From" must be lower or equal to the "Date To"'
    },
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while communication with the server. Unable to get data for << ReportName >>.'
    },
    GetCurrencyListFailed: {
        key: 'GetCurrencyListFailed',
        message: 'Error while communication with the server. Unable to get currency list.'
    },
    ...CommonMessages
};
